import flow from "./flow/index";

export default angular.module("modules.demo", [flow])
	.name;


/** WEBPACK FOOTER **
 ** ./src/modules/demo/index.js
 **/